import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cn } from "../lib/cn";

/** "Ma. Liza Santos" -> "LS" (first + last word initials, ignoring abbreviations like "Ma."). */
export function initialsOf(name: string): string {
  const raw = name.trim().split(/\s+/).filter(Boolean);
  const meaningful = raw.filter((word) => !word.endsWith("."));
  const words = (meaningful.length > 0 ? meaningful : raw).map((word) => word.replace(/[^\p{L}\p{N}]/gu, ""));
  const first = words[0]?.[0] ?? "";
  const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase();
}

export interface AvatarProps {
  name: string;
  src?: string;
  className?: string;
}

export function Avatar({ name, src, className }: AvatarProps) {
  return (
    <AvatarPrimitive.Root className={cn("avatar overflow-hidden", className)}>
      {src ? <AvatarPrimitive.Image src={src} alt={name} className="size-full object-cover" /> : null}
      <AvatarPrimitive.Fallback delayMs={src ? 300 : undefined} aria-label={name}>
        {initialsOf(name)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
